const default_rubicon_config = {
    active: true,

    'all': {
        accountId: '17174',
        siteId: '163770'
    },
    'efe_hp_728': {
        zoneId: '1485196'
    },
    'efe_topics_160': {
        zoneId: '1485208'
    },
    'efe_topics_bottom_728': {
        zoneId: '1485204'
    },
    'efe_topics_mid_728_1': {
        zoneId: '1485198'
    },
    'efe_topics_mid_728_2': {
        zoneId: '1485200'
    },
    'efe_topics_mid_728_3': {
        zoneId: '1485202'
    },
    'efe_300_mid': {
        zoneId: '1485206'
    }

};
export const rubicon_config = default_rubicon_config;
